import { Directive, Input } from "@angular/core";
import { NzCardGridDirective } from "ng-zorro-antd/card";
import { InputBoolean } from "ng-zorro-antd/core/util";

@Directive({
  selector: "[ui-card-grid]",
  exportAs: "uiCardGrid",
  host: {
    "[class.ant-card-hoverable]": "nzHoverable",
  },
})
export class UiCardGridDirective extends NzCardGridDirective {
  @Input("uiHoverable") @InputBoolean() public nzHoverable = true;
}
